import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import TopRibbon from "../topRibbon/TopRibbon";
import { BrookshireBrotherLogoWithTagline } from "../../../assets";
import "./navbar.scss";
import { FaHome, FaListAlt, FaGlobe } from "react-icons/fa";

import { Drawer, IconButton, List, ListItem, ListItemText } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";

import { CiMenuBurger } from "react-icons/ci";

const Navbar: React.FC = (): JSX.Element => {
	const navigate = useNavigate();

	const [drawerOpen, setDrawerOpen] = useState(false);
	const [benefitsOpen, setBenefitsOpen] = useState(false);

	const handleDrawerToggle = () => {
		setDrawerOpen(!drawerOpen);
	};

	const handleDrawerItemClick = (path: string) => {
		navigate(path);
		setDrawerOpen(false); // Close the drawer after navigating
	};
	const toggleBenefits = () => {
		setBenefitsOpen(!benefitsOpen);
	};
	return (
		<>
			<TopRibbon />

			<div className="navbar">
				<a href="https://www.nexcaliber.com/" target="_blank" className="nextButton" rel="noreferrer">
					<button className="nav-button" />
				</a>

				<img
					className="logoImg"
					src={BrookshireBrotherLogoWithTagline}
					alt="logo of brookshirebrother"
					onClick={() => navigate("/")}
				/>

				{/* <div className="desktop-menu"> */}
				<div className="dropdown">
					<button className="dropbtn"> Benefits &#8628; </button>

					<div className="dropdown-content">
						<Link to="/plans/core">
							<span>Core Plans</span>
						</Link>
						<Link to="/plans/veb">
							<span>VEB Plans</span>
						</Link>
					</div>
				</div>
				<Link to="/" className="home-router">
					<span>Home</span>
				</Link>
				{/* </div> */}

				{/* Hamburger icon for smaller screens */}
				<IconButton className="hamburger-icon" onClick={handleDrawerToggle}>
					<CiMenuBurger />
				</IconButton>

				{/* Drawer for mobile menu */}
				<Drawer
					anchor="right"
					open={drawerOpen}
					onClose={handleDrawerToggle}
					classes={{ paper: "custom-drawer" }}
				>
					<List style={{ marginTop: "20px" }}>
						<ListItem button onClick={() => handleDrawerItemClick("/")}>
							<FaHome style={{ marginRight: "20px" }} />
							<ListItemText primary="HOME" />
						</ListItem>
						<ListItem button onClick={toggleBenefits}>
							{benefitsOpen ? (
								<FaListAlt style={{ marginRight: "20px" }} />
							) : (
								<FaListAlt style={{ marginRight: "20px" }} />
							)}
							<ListItemText primary="BENEFITS" />
						</ListItem>
						{benefitsOpen && (
							<>
								<ListItem button onClick={() => handleDrawerItemClick("/plans/core")}>
									<span style={{ paddingRight: "5px", marginLeft: "20px" }}>&#8618;</span>
									<ListItemText primary="CORE PLANS" />
								</ListItem>
								<ListItem button onClick={() => handleDrawerItemClick("/plans/veb")}>
									<span style={{ paddingRight: "5px", marginLeft: "20px" }}>&#8618;</span>
									<ListItemText primary="VEB PLANS" />
								</ListItem>
							</>
						)}
						<ListItem
							button
							onClick={() => window.open("https://www.nexcaliber.com/", "_blank")}
							style={{ margin: "10px 0", textAlign: "center" }}
						>
							<FaGlobe style={{ marginRight: "10px" }} />
							<button className="nav-button" />
						</ListItem>
					</List>
				</Drawer>
			</div>
		</>
	);
};

export default Navbar;
